import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, location, paramsURL, toggle,
    FetchData, Helpers,

    defaultData,

    //------------- Forms
    Forms,

    globalStates

}) => {

    const { convertToFloat } = Helpers

    // Estado para bloquear botones mientras una operación al backend está en curso
    const [pending, setPending] = useState({})

    const withPending = (key, fn) => async (...args) => {
        if (pending[key]) return
        setPending(p => ({ ...p, [key]: true }))
        try {
            return await fn(...args)
        } finally {
            setPending(p => ({ ...p, [key]: false }))
        }
    }

    // Formateador de números
    const numberFormatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        maximumFractionDigits: 2
    });

    const openModal = (_, title, compont, dataRequest) => {
        toggle(_, title, compont, dataRequest)
    }

    const closeModal = () => {
        toggle()
    }

    const handleClickShowForm = (openingMode) => {
        const { setShowForm, setFormOpeningMode } = globalStates
        setFormOpeningMode(openingMode)
        setShowForm(true)
    }

    const handleClickHideForm = () => {
        const { setShowForm, setStepApplilication, setShowSection, setImagesCurrentIndex } = globalStates;

        const { fetchAllCreditsApplication: { executeFetchAllCreditsApplications } } = FetchData;

        const { FormRequestGlobal: { onResetForm: onResetGlobal }, FormCollateral } = Forms;
        const { setFormState: setCollateralState } = FormCollateral;

        setShowSection("HOME");
        setImagesCurrentIndex?.(0);

        setCollateralState(prev => ({
            ...prev,
            acceptedFiles: [],
            fileRejections: [],
            images: [],
            idcollateral: 0,
        }));

        onResetGlobal();
        executeFetchAllCreditsApplications();

        setStepApplilication(0);
        setShowForm(false);
    };
    const handleClickReturnStep = () => {
        const { stepApplilication, setStepApplilication } = globalStates
        setStepApplilication(stepApplilication - 1)
    }

    const handleClickNextStep = () => {
        const { stepApplilication, setStepApplilication } = globalStates
        setStepApplilication(stepApplilication + 1)
    }



    // ===============================
    // GARANTÍAS - IMÁGENES (ADMIN)
    // ===============================

    const handleClickShowCollateralImages = async (idcollateral, openingMode = "READONLY") => {
        const { FormCollateral: { setFormState } } = Forms;
        const { setShowSection, setImagesCurrentIndex, setFormOpeningMode } = globalStates;

        setFormOpeningMode(openingMode);

        // reset index
        setImagesCurrentIndex && setImagesCurrentIndex(0);

        // setea el colateral actual
        setFormState(prev => ({
            ...prev,
            idcollateral,
            images: [] // opcional limpiar antes de cargar
        }));

        // dispara fetch (si existe en FetchData)
        const exec = FetchData?.fetchCollateralImages?.executeFetchCollateralImages;
        exec && exec();

        // cambia a vista imágenes
        setShowSection("IMAGE");
    };

    const handleClickCloseImage = () => {
        const { setShowSection, setImagesCurrentIndex } = globalStates;
        const { FormCollateral: { setFormState } } = Forms;

        setShowSection("HOME");
        setImagesCurrentIndex(0);

        setFormState(prev => ({
            ...prev,
            acceptedFiles: [],
            fileRejections: [],
            images: [],
            idcollateral: 0,
        }));
    };

    const handleNextCollateralImage = () => {
        const { FormCollateral: { formState } } = Forms;
        const images = formState.images || [];
        const { setImagesCurrentIndex } = globalStates;

        if (!images.length) return;

        setImagesCurrentIndex(prev => (prev + 1 < images.length ? prev + 1 : 0));
    };

    const handlePreviousCollateralImage = () => {
        const { FormCollateral: { formState } } = Forms;
        const images = formState.images || [];
        const { setImagesCurrentIndex } = globalStates;

        if (!images.length) return;

        setImagesCurrentIndex(prev => (prev - 1 >= 0 ? prev - 1 : images.length - 1));
    };

    const handleClickCleanUpCollateralImagesFiles = () => {
        const { FormCollateral: { setFormState } } = Forms;

        setFormState(prev => ({
            ...prev,
            fileRejections: [],
            acceptedFiles: [],
            dropzoneKey: (prev.dropzoneKey || 0) + 1, // por si tu dropzone se queda "pegado"
        }));
    };

    const onSubmitCollateralImages = withPending('submitCollateralImages', async (e) => {
        e.preventDefault();

        const { getCurrentDate } = Helpers;
        const { FormCollateral: { formState, setFormState } } = Forms;

        // ✅ si está en READONLY, no debería subir
        if (globalStates.formOpeningMode === "READONLY") {
            alertMessage({ title: "FAIL", message: "Solo lectura: no se puede subir imágenes", rows: [] });
            return;
        }

        if (formState.idcollateral <= 0) {
            alertMessage({ title: "FAIL", message: "No hay garantía seleccionada", rows: [] });
            return;
        }

        if (!formState.acceptedFiles || formState.acceptedFiles.length <= 0) {
            alertMessage({ title: "FAIL", message: "No se ha cargado ninguna imagen", rows: [] });
            return;
        }

        const _data = new FormData();
        _data.append("usuario_creo", user.username);
        _data.append("fecha_creo", getCurrentDate());

        formState.acceptedFiles.forEach((file) => {
            _data.append("images", file); // confirma que tu backend recibe "images"
        });

        await marvarApi
            .post(`/credits/collateral/${formState.idcollateral}/images`, _data)
            .then(({ data }) => {
                alertMessage(data);
                if (data.title === "OK") {
                    setFormState(prev => ({
                        ...prev,
                        acceptedFiles: [],
                        fileRejections: []
                    }));
                    const exec = FetchData?.fetchCollateralImages?.executeFetchCollateralImages;
                    exec && exec();
                }
            })
            .catch(err => console.log("API ERROR:", err));
    });

    const handleClickDeleteCollateralImage = (idimagen) => {
        // ✅ Admin sí puede eliminar si está en EDITABLE. Si lo quieres siempre permitido, quita la validación.
        if (globalStates.formOpeningMode === "READONLY") return;

        const { FormCollateral: { formState } } = Forms;
        const idcollateral = formState.idcollateral;

        Swal.fire({
            title: "¿Desea eliminar esta imagen?",
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: "Eliminar",
            cancelButtonText: "Cancelar",
        }).then(withPending('deleteCollateralImage', async (result) => {
            if (!result.isConfirmed) return;
            await marvarApi
                .delete(`/credits/collateral/${idcollateral}/images/${idimagen}`)
                .then(({ data }) => {
                    alertMessage(data);
                    if (data.title === "OK") {
                        const exec = FetchData?.fetchCollateralImages?.executeFetchCollateralImages;
                        exec && exec();
                    }
                })
                .catch(err => console.log("API ERROR:", err));
        }));
    };


    const handleClickCleanUpFiles = (event) => {
        const { FormRequestGlobal: { setFormState } } = Forms

        // const { fetchAllDeposits } = FetchData
        // const { executeFetchAllDeposits } = fetchAllDeposits

        setFormState(prevState => ({
            ...prevState,
            fileRejections: [],
            acceptedFiles: []
        }))

        // executeFetchAllDeposits()

    }

    //     const handleClickDeleteDocument = (iddocumento) => {

    //         const { fetchAllFiles } = FetchData
    //         const { executeFetchAllFiles } = fetchAllFiles
    //         Swal.fire({
    //             title: '¿Desea eliminar este registro?',
    //             showConfirmButton: true,
    //             showCancelButton: true,
    //             confirmButtonText: 'Eliminar',
    //             cancelButtonText: 'Cancelar'
    //         }).then(async result => {
    //             if (result.isConfirmed) {
    //                 await marvarApi.delete(`/leases/common/delete-document/${iddocumento}`)
    //                 .then( ({ data }) => {
    //                     alertMessage(data)
    //                     if (data.title === 'OK') {
    //                         executeFetchAllFiles()
    //                         // closeModal()
    //                         }else{

    //                         }
    //                 }).catch(error => {
    //                     console.log('API ERROR: ', error)
    //                 })
    //             }
    //         })
    //     }

    //     const handleClickDeleteDeposit = (iddocumento) => {

    //         const { fetchAllDeposits } = FetchData
    //         const { executeFetchAllDeposits } = fetchAllDeposits
    //         Swal.fire({
    //             title: '¿Desea eliminar este registro?',
    //             showConfirmButton: true,
    //             showCancelButton: true,
    //             confirmButtonText: 'Eliminar',
    //             cancelButtonText: 'Cancelar'
    //         }).then(async result => {
    //             if (result.isConfirmed) {
    //                 await marvarApi.delete(`/leases/management/delete-deposit/${iddocumento}`)
    //                 .then( ({ data }) => {
    //                     alertMessage(data)
    //                     if (data.title === 'OK') {
    //                         executeFetchAllDeposits()
    //                         // closeModal()
    //                         }else{

    //                         }
    //                 }).catch(error => {
    //                     console.log('API ERROR: ', error)
    //                 })
    //             }
    //         })
    //     }

    //     const handleChangeTotalMonths = ({ target }) => {
    //         // console.log(event);
    //         const { FormLeases } = Forms
    //         const { formState ,setFormState } = FormLeases

    //         // const data = JSON.parse(event.target.value || null)

    //         const { name, value } = target;
    //         setFormState({
    //             ...formState,
    //             [ name ]: value,
    //             contrato_total_alquiler: (formState.contrato_costo_alquiler * (value || 0))
    //         });
    //     }

    const handleChangeTypeCurrency = (event) => {

        //HOOKS
        const { FormDeposit } = Forms
        const { setFormState, formState } = FormDeposit
        const { clean_deposito_monto, deposito_tipo_cambio } = formState

        const { name, value } = event.target

        //Verificamos si tiene data
        const tipo_cambio = deposito_tipo_cambio !== '' ? deposito_tipo_cambio : 0;


        if (value === 'DOLAR') {
            setFormState(prevState => ({
                ...prevState,
                [name]: value,
                deposito_quetzales: numberFormatter.format(clean_deposito_monto * tipo_cambio),
                deposito_dolares: numberFormatter.format(clean_deposito_monto),
                clean_deposito_quetzales: (clean_deposito_monto * tipo_cambio),
                clean_deposito_dolares: clean_deposito_monto
            }))
        } else if (value === 'QUETZAL') {
            setFormState(prevState => ({
                ...prevState,
                [name]: value,
                deposito_quetzales: numberFormatter.format(clean_deposito_monto),
                deposito_dolares: numberFormatter.format(clean_deposito_monto / tipo_cambio),
                clean_deposito_quetzales: clean_deposito_monto,
                clean_deposito_dolares: (clean_deposito_monto / tipo_cambio)
            }))
        }
    }


    const onSubmitFormApplies = async (e) => {

        e.preventDefault()

        handleClickNextStep()

    }

    const onSendLogs = withPending('sendLogs', async (e) => {


        const { FormRequestGlobal } = Forms
        const { formState, setFormState } = FormRequestGlobal

        const { fetchInfoObservations: { executeFetchAllObservations } } = FetchData


        const { getCurrentDate } = Helpers

        await marvarApi.post(`/credits/common/log-vehicle/${formState.idcredito}`, {
            idusuario: user.uid,
            log_fecha: getCurrentDate(),
            log_observacion: formState.aprobacion_observaciones,
            log_departamento: "Gestor"
        })
            .then(({ data }) => {
                alertMessage(data)
                if (data.title === 'OK') {
                    setFormState((prevState) => ({
                        ...prevState,
                        aprobacion_observaciones: ''
                    }))
                    executeFetchAllObservations()
                }
            })

    })

    const onSubmitFormFiles = withPending('submitFiles', async (e) => {

        e.preventDefault()

        const { FormRequestGlobal: { formState, setFormState } } = Forms
        const { getCurrentDate } = Helpers


        const { fetchAllFiles: { executeFetchAllFiles }, fetchInfoApplication: { executeFetchInfoApplication } } = FetchData



        if (formState.acceptedFiles.length <= 0) {
            const messageCustom = {
                message: 'No se ha cargado nigun archivo',
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom)
            return
        }

        const _data = new FormData();

        _data.append('idcredito', formState.idcredito);
        _data.append('department', 'ADMINISTRADOR');
        _data.append('usuario_creo', user.username);
        _data.append('fecha_creo', getCurrentDate());


        formState.acceptedFiles.forEach((file, index) => {
            _data.append(`attachmentt`, file);
        });

        if (formState.idcredito > 0) {

            await marvarApi.post(`/credits/common/create-document`, _data)
                .then(async ({ data }) => {

                    if (data.title === 'OK') {
                        setFormState(prevState => ({
                            ...prevState,
                            acceptedFiles: [],
                            fileRejections: []
                        }))
                        executeFetchAllFiles()
                    }
                    alertMessage(data)
                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })

        }
    })

    const handleClickDeleteDocument = (iddocumento) => {

        const { fetchAllFiles } = FetchData
        const { executeFetchAllFiles } = fetchAllFiles
        Swal.fire({
            title: '¿Desea eliminar este registro?',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then(withPending('deleteDocument', async result => {
            if (!result.isConfirmed) return
            await marvarApi.delete(`/credits/common/delete-document/${iddocumento}`)
                .then(({ data }) => {
                    alertMessage(data)
                    if (data.title === 'OK') {
                        executeFetchAllFiles()
                        // closeModal()
                    } else {

                    }
                }).catch(error => {
                    console.log('API ERROR: ', error)
                })
        }))
    }


    const handleClickShowModal = (_, title, compont, dataRequest, modalOpeningMode) => {
        const { setModalOpeningMode } = globalStates
        setModalOpeningMode(modalOpeningMode)
        openModal(_, title, compont, dataRequest)
    }

    const handleClickCloseModal = () => {

        //HOOKS
        const { FormDeposit, FormCollateral } = Forms
        const { onResetForm } = FormDeposit
        const onResetFormCollateral = FormCollateral.onResetForm
        onResetForm()
        onResetFormCollateral()
        closeModal()
    }

    const onSubmitFormDeposits = withPending('submitDeposit', async (e) => {

        e.preventDefault()

        const { FormDeposit, FormRequestGlobal } = Forms
        const { formState, onResetForm } = FormDeposit
        const formStateGlobal = FormRequestGlobal.formState

        const { fetchAllDeposits: { executeFetchAllDeposits } } = FetchData

        const { getCurrentDate } = Helpers



        const _data = {
            aprobacion_check: formState.aprobacion_check,
            aprobacion_referencia_ach: formState.aprobacion_referencia_ach,
            aprobacion_observaciones: formState.aprobacion_observaciones,
            aprobacion_usuario: user.username,
            aprobacion_fecha: getCurrentDate()
        }

        await marvarApi.put(`/credits/admin-managements/aprobacion-check-deposit/${formState.iddeposit}`, _data)
            .then(({ data }) => {

                alertMessage(data)

                if (data.title === 'OK') {
                    onResetForm()
                    executeFetchAllDeposits()
                    closeModal()
                }

            })
            .catch(error => {
                console.log('API ERROR: ', error)
            })

    })

    const handleChangeAmount = (event) => {

        //HOOKS
        const { FormDeposit } = Forms
        const { setFormState, formState, onInputChangeForNumber } = FormDeposit
        const { deposito_tipo_cambio } = formState

        const { value } = event.target

        onInputChangeForNumber(event)
        const clean_value = convertToFloat(value)

        //Verificamos si tiene data
        const tipo_cambio = deposito_tipo_cambio !== '' ? parseFloat(deposito_tipo_cambio) : 0;

        if (formState.deposito_moneda === 'DOLAR') {
            setFormState(prevState => ({
                ...prevState,
                deposito_quetzales: numberFormatter.format(clean_value * tipo_cambio),
                deposito_dolares: numberFormatter.format(clean_value),
                clean_deposito_quetzales: (clean_value * tipo_cambio),
                clean_deposito_dolares: clean_value
            }))
        } else if (formState.deposito_moneda === 'QUETZAL') {
            setFormState(prevState => ({
                ...prevState,
                deposito_quetzales: numberFormatter.format(clean_value),
                deposito_dolares: numberFormatter.format(clean_value / tipo_cambio),
                clean_deposito_quetzales: clean_value,
                clean_deposito_dolares: (clean_value / tipo_cambio)
            }))
        }
    }

    const handleChangeExchangeRate = (event) => {

        //HOOKS
        const { FormDeposit } = Forms
        const { setFormState, formState } = FormDeposit
        const { clean_deposito_monto } = formState

        const { name, value } = event.target

        //Verificamos si tiene data
        // const monto = deposito_monto !== '' ? deposito_monto : 0;
        const tipo_cambio = value !== '' ? parseFloat(value) : 0;

        if (formState.deposito_moneda === 'DOLAR') {
            setFormState(prevState => ({
                ...prevState,
                [name]: value,
                deposito_quetzales: numberFormatter.format(clean_deposito_monto * tipo_cambio),
                deposito_dolares: numberFormatter.format(clean_deposito_monto),
                clean_deposito_quetzales: (clean_deposito_monto * tipo_cambio),
                clean_deposito_dolares: clean_deposito_monto
            }))
        } else if (formState.deposito_moneda === 'QUETZAL') {
            setFormState(prevState => ({
                ...prevState,
                [name]: value,
                deposito_quetzales: numberFormatter.format(clean_deposito_monto),
                deposito_dolares: (tipo_cambio === 0) ? 0 : numberFormatter.format(clean_deposito_monto / tipo_cambio),
                clean_deposito_quetzales: clean_deposito_monto,
                clean_deposito_dolares: (tipo_cambio === 0) ? 0 : (clean_deposito_monto / tipo_cambio)
            }))
        } else {
            setFormState(prevState => ({
                ...prevState,
                [name]: value
            }))
        }
    }

    const handleClickFetchInfoDeposit = async (iddeposit) => {

        const { FormDeposit: { onResetForm } } = Forms


        const { fetchInfoDeposit } = FetchData
        const { setParamsToSearch, executeFetchInfoDeposit } = fetchInfoDeposit

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()

        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setParamsToSearch({ iddeposit: iddeposit })
        executeFetchInfoDeposit()

        // setParamsToSearchDeposit({idcontrato: idcontrato})

        handleClickShowModal('', 'Formulario de depositos', 'deposits-section', {}, 'READONLY')

    }

    const handleClickDownloadImage = withPending('downloadImage', async (customFileName, openUrl) => {

        try {
            const response = await fetch(openUrl);
            const blob = await response.blob();

            // Crear un enlace temporal
            const enlaceTemporal = document.createElement('a');
            enlaceTemporal.href = window.URL.createObjectURL(blob);
            enlaceTemporal.download = customFileName; // Puedes cambiar el nombre del archivo
            document.body.appendChild(enlaceTemporal);

            // Simular clic en el enlace para iniciar la descarga
            enlaceTemporal.click();

            // Eliminar el enlace temporal
            document.body.removeChild(enlaceTemporal);

            toast.success('Se ha descargado la imagen');

        } catch (error) {
            console.error('Error al descargar la imagen', error);
        }

    })

    const handleClickDeleteDeposit = (iddeposit) => {

        const { fetchAllDeposits } = FetchData
        const { executeFetchAllDeposits } = fetchAllDeposits
        Swal.fire({
            title: '¿Desea eliminar este registro?',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/credits/common/delete-deposit/${iddeposit}`)
                    .then(({ data }) => {
                        alertMessage(data)
                        if (data.title === 'OK') {
                            executeFetchAllDeposits()
                        } else {

                        }
                    }).catch(error => {
                        console.log('API ERROR: ', error)
                    })
            }
        })
    }

    const onSubmitFormCollateral = withPending('submitCollateral', async (e) => {

        e.preventDefault()

        const { getCurrentDate } = Helpers

        //HOOKS
        const { FormCollateral: { formState }, FormRequestGlobal } = Forms
        const formStateGlobal = FormRequestGlobal.formState

        const { modalOpeningMode } = globalStates

        const { fetchAllCollateral: { executeFetchCollateral } } = FetchData

        //Validaciones generales
        if (formState.type_collateral === '') {
            const messageCustom = {
                message: 'Debe seleccionar un tipo de garantia',
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom)
            return
        }

        let _data = {
            idcredito: formStateGlobal.idcredito,
            title: formState.title,
            type_collateral: formState.type_collateral,
            estate: formState.estate,
            folio: formState.folio,
            department: formState.department,
            book: formState.book,
            description: formState.description,
            valor: formState.clean_valor,
            marca: formState.marca,
            modelo: formState.modelo,
            linea: formState.linea,
            color: formState.color,
            matricula: formState.matricula,
            chasis: formState.chasis,
        }


        if (formState.idcollateral > 0) {

            if (modalOpeningMode === 'EDITABLE') {

                _data['usuario_modifico'] = user.username;
                _data['fecha_modifico'] = getCurrentDate();

                await marvarApi.put(`/credits/mgmt-managements/collateral/${formState.idcollateral}`, _data)
                    .then(({ data }) => {

                        alertMessage(data)

                        if (data.title === 'OK') {
                            executeFetchCollateral()
                            handleClickCloseModal()
                        }

                    }).catch(error => { console.log('API ERROR: ', error) })
            } else {
                handleClickCloseModal()
            }

        } else {

            _data['usuario_creo'] = user.username;
            _data['fecha_creo'] = getCurrentDate();

            await marvarApi.post(`/credits/mgmt-managements/collateral`, _data)
                .then(({ data }) => {

                    alertMessage(data)

                    if (data.title === 'OK') {
                        executeFetchCollateral()
                        handleClickCloseModal()
                    }

                }).catch(error => { console.log('API ERROR: ', error) })
        }

    })


    const handleClickFetchInfoCollateral = async (idcollateral, modeOpening) => {

        const { FormCollateral: { onResetForm, setFormState } } = Forms

        const { fetchInfoCollateral: { setParamsToSearch, executeFetchCollateral } } = FetchData

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()

        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setParamsToSearch({ idcollateral: idcollateral })
        executeFetchCollateral()

        setFormState(prevState => ({
            ...prevState,
            idcollateral: idcollateral
        }))


        handleClickShowModal('', 'Formulario de Garantias', 'collateral-section', {}, modeOpening)

    }

    const handleClickDeleteCollateral = (idcollateral) => {

        const { fetchAllCollateral: { executeFetchCollateral } } = FetchData
        Swal.fire({
            title: '¿Desea eliminar este registro?',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/credits/mgmt-managements/delete-collateral/${idcollateral}`)
                    .then(({ data }) => {
                        alertMessage(data)
                        if (data.title === 'OK') {
                            executeFetchCollateral()
                        } else {

                        }
                    }).catch(error => {
                        console.log('API ERROR: ', error)
                    })
            }
        })
    }

    const handleClickFetchInfoApplication = async (idcredito, idcotizacion, modeOpening) => {

        const { FormRequestGlobal: { onResetForm, setFormState } } = Forms

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()

        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setFormState(prevState => ({
            ...prevState,
            idcredito: idcredito,
            idcotizacion: idcotizacion,
        }))
        // setParamsToSearchDeposit({idcontrato: idcontrato})

        handleClickShowForm(modeOpening)

    }

    const handleClickDeleteApplication = (idcredito) => {

        const { fetchAllCreditsApplication: { executeFetchAllCreditsApplications } } = FetchData
        Swal.fire({
            title: '¿Desea eliminar este registro?',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar',
            text: 'Esta acción eliminara toda la informacion relacionada con esta solicitud. Esta accion no se puede deshacer'
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/credits/mgmt-managements/${idcredito}`)
                    .then(({ data }) => {
                        alertMessage(data)
                        if (data.title === 'OK') {
                            executeFetchAllCreditsApplications()
                        }
                    }).catch(error => {
                        console.log('API ERROR: ', error)
                    })
            }
        })
    }

    const handleClickApproval = async () => {
        //HOOKS
        const { FormRequestGlobal } = Forms
        const { formState, setFormState } = FormRequestGlobal
        const { getCurrentDate } = Helpers

        console.log('Accion handleClickApproval Creditos');


        if (formState.aprobacion_check === 'Devuelto a Gestor') {
            await marvarApi.put(`/credits/legal/aprobacion-check/${formState.idcredito}`, { aprobacion_check: 'Devuelto a Juridico', aprobacion_usuario: user.username, aprobacion_fecha: getCurrentDate() })
                .then(({ data }) => {
                    alertMessage(data)
                    handleClickHideForm()
                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })
        } else {
            handleClickHideForm()
        }
    }

    const handleClickUpdateAprobacion = withPending('updateAprobacion', async () => {

        const { getCurrentDate } = Helpers

        const { FormRequestGlobal: { formState } } = Forms

        const { fetchAllCreditsApplication: { executeFetchAllCreditsApplications } } = FetchData

        let endpoint
        let _body

        if ((formState.aprobacion_check === 'Aprobado') && (formState.old_aprobacion_check === 'Pendiente Aprobacion' || formState.old_aprobacion_check === 'Devuelto a Gestor')) {
            endpoint = `/credits/legal-managements/aprobacion-check/${formState.idcredito}`;
            _body = {
                idcotizacion: formState.idcotizacion,
                aprobacion_check: 'Pendiente Contrato',
                aprobacion_usuario: user.username,
                aprobacion_fecha: getCurrentDate()
            }
        } else {
            endpoint = `/credits/admin-managements/aprobacion-check/${formState.idcredito}`;
            _body = {
                idcotizacion: formState.idcotizacion,
                aprobacion_check: formState.aprobacion_check,
                aprobacion_usuario: user.username,
                aprobacion_fecha: getCurrentDate()
            }
        }

        await marvarApi.put(endpoint, _body).then(({ data }) => {
            alertMessage(data)
            if (data.title === 'OK') {
                executeFetchAllCreditsApplications()
                handleClickHideForm()
            }
        })
            .catch(error => {
                console.log('API ERROR: ', error)
            })
    })




    return Object.freeze({
        pending,
        handleClickShowForm,
        handleClickHideForm,
        onSubmitFormApplies,
        onSendLogs,
        handleClickCleanUpFiles,
        handleClickReturnStep,
        handleClickNextStep,
        onSubmitFormFiles,
        handleClickDeleteDocument,
        handleClickShowModal,
        handleClickCloseModal,
        onSubmitFormDeposits,
        handleChangeTypeCurrency,
        handleChangeAmount,
        handleChangeExchangeRate,
        handleClickFetchInfoDeposit,
        handleClickDownloadImage,
        handleClickDeleteDeposit,
        onSubmitFormCollateral,
        handleClickFetchInfoCollateral,
        handleClickDeleteCollateral,
        handleClickFetchInfoApplication,
        handleClickDeleteApplication,
        handleClickApproval,
        handleClickUpdateAprobacion,
        handleClickShowCollateralImages,
        handleClickCloseImage,
        handleNextCollateralImage,
        handlePreviousCollateralImage,
        handleClickCleanUpCollateralImagesFiles,
        onSubmitCollateralImages,
        handleClickDeleteCollateralImage,
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {


    if (res) {
        const { title, message } = res
        if (title === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}